"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayGroupEntity = void 0;
class DisplayGroupEntity {
    id;
    name;
    owner;
    displayIds;
    managed;
    /** @deprecated Use audience_stats daily totals. */
    approximateDailyImpressions;
    audience_stats;
    last_updated_audience_stats;
    createdAt;
    updatedAt;
}
exports.DisplayGroupEntity = DisplayGroupEntity;
